export default "__VITE_ASSET__DEZbQ$cm__"